import { transaction } from 'mobx'
import { CATEGORY_IDS } from 'constants/categories'
import { contentFocusTopBrandIdsAndLogos } from 'constants/welcome'
import { FetchProps } from 'helpers/redial'
import { IService } from 'services'

const doBrandsRequest = async (service: IService, ids: string[]) =>
  service.brands.requestByIds(ids, undefined, {
    strategy: 'cache_or_network',
  })

const doContentTopBrandsByIdsRequest = async (service: IService) =>
  doBrandsRequest(
    service,
    contentFocusTopBrandIdsAndLogos.map(brand => brand.id),
  )

const doCategoriesByIdsRequest = async (service: IService, ids: string[]) =>
  service.categories.requestByCategoryIds(ids, {
    strategy: 'cache_or_network',
  })

const doCategoriesContentFocusCategoryRequest = async (service: IService) =>
  doCategoriesByIdsRequest(service, [
    CATEGORY_IDS.female.root,
    CATEGORY_IDS.female.bekleidung,
    CATEGORY_IDS.male.root,
    CATEGORY_IDS.male.bekleidung,
    CATEGORY_IDS.kids.root,
  ])

const doStaticImagesByIdsRequest = async (service: IService, ids: string[]) =>
  service.staticImages.requestByContext(ids)

const doStaticImagesContentRequest = async (service: IService) =>
  doStaticImagesByIdsRequest(service, [
    'welcomepage_genderselect_all_teaser',
    'welcomepage_usp_teaser',
    'welcomepage_brand_teaser_1',
    'welcomepage_brand_teaser_2',
    'welcomepage_brand_teaser_3',
    'welcomepage_brand_teaser_4',
    'welcomepage_brand_teaser_5',
    'welcomepage_brand_teaser_6',
  ])

export default {
  fetch: async ({ store, service, ssr }: FetchProps) => {
    await Promise.all([
      doCategoriesContentFocusCategoryRequest(service),
      doStaticImagesContentRequest(service),
      doContentTopBrandsByIdsRequest(service),
    ])

    if (!ssr) {
      transaction(() => {
        store.entities.staticImages = { ...store.entities.staticImages }
        store.entities.categories = { ...store.entities.categories }
        store.entities.brands.hydrate(store.entities.brands)
      })
    }
  },
}
